import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/elementix-landing-v2/elementix-landing-v2/app/home-page.tsx");
